<ion-grid class="ion-no-padding" style="padding-left: 12px;height: 56px;">
	<ion-row>
		<ion-col>
			<h1 class="ion-no-margin ion-text-nowrap" style="margin-top: 6px;">Menu</h1>
			<div class="colapse">
				<ion-button fill="clear" shape="round" color="light"
					style="margin-top: 12px; margin-right: 8px; --padding-start: 8px; --padding-end: 8px;"
					(click)="onCloseMenu()">
					<ion-icon slot="icon-only" [name]="isOpen ? 'chevron-back-outline': 'chevron-forward-outline'"></ion-icon>
				</ion-button>
			</div>
		</ion-col>
	</ion-row>
</ion-grid>

<!--<ion-toolbar padding>
		

	 <ion-grid>
		<ion-row>
			<ion-buttons>
				<ion-menu-button></ion-menu-button>
			</ion-buttons>
		</ion-row>
		<ion-row margin-vertical>
			<ion-col padding-start nowrap>
				<img float-left [src]="Session?.Imagem" />
				<h5 float-left no-margin margin-top padding-start>{{ Session?.NomeCompleto }}</h5>
				<p float-left no-margin padding-start>{{ 'NAME_OF_ENTERPRISE' | translate }}</p>
			</ion-col>
		</ion-row>
	</ion-grid> 
	
</ion-toolbar>-->